import React from "react";
import FlxdeckHeader from "./FlxdeckHeader";
import Form from "../../common/Form/Form";
import "./style.css";

const FlxMain = () => {
  return (
    <div className="flxdeck">
      <FlxdeckHeader />
      <Form />
    </div>
  );
};

export default FlxMain;
